(function (Drupal, drupalSettings) {
  Drupal.behaviors.leafletSenior = {
    attach: function (context, settings) {
      const mapElement = context.querySelector(".pole_2 #map");
      if (mapElement && !mapElement.dataset.leafletSeniorProcessed) {
        mapElement.dataset.leafletSeniorProcessed = "true";

        const planes = [
          [
            "<strong>Notre-Dame de La Fontaine</strong>Maison de repos et de soins<br>Rue du Chateau 28<br>7950 Chièvres<br><a href='tel:068 65 71 90' class='tel'>068 65 71 90</a>",
            50.590343,
            3.806929,
          ],
          [
            "<strong>Les Buissonnets</strong>Maison de repos et de soins, Résidence-services et court-séjour<br>Avenue de l’Europe 65<br>7100 Saint-Vaast<br><a href='tel:064 23 43 11' class='tel'>064 23 43 11</a>",
            50.46276,
            4.167655,
          ],
          [
            "<strong>La Visitation</strong>Maison de repos et de soins<br>Clos des Champs 101<br>6540 Lobbes<br><a href='tel:071 55 95 10' class='tel'>071 55 95 10</a>",
            50.34845082264787,
            4.27050627807728,
          ],
          [
            "<strong>La Seniorie de Longtain</strong>Maison de repos et de soins<br>Rue des Rentiers 86<br>7100 La Louvière<br><a href='tel:064 23 67 67' class='tel'>064 23 67 67</a>",
            50.476972,
            4.208845,
          ],
          [
            "<strong>Les Chartriers</strong>Maison de repos<br>Rue des Chartriers 12<br>7000 Mons<br><a href='tel:065 40 22 22' class='tel'>065 40 22 22</a>",
            50.450326,
            3.95342,
          ],
          [
            "<strong>Comme chez Soi</strong>Maison de repos et de soins et court-séjour<br>Rue Charles Stiernon 16<br>7190 Ecaussinnes<br><a href='tel:067 49 04 20' class='tel'>067 49 04 20</a>",
            50.560488,
            4.154199,
          ],
          [
            "<strong>Le Rambour</strong>Maison de repos et de soins<br>Chaussée Brunehault 36<br>7080 Sars-La-Bruyère<br><a href='tel:065 61 34 00' class='tel'>065 61 34 00</a>",
            50.366337,
            3.87964,
          ],
          [
            "<strong>Le Planty</strong>Résidence-Services<br>Chaussée Brunehault 9 A<br>7080 Sars-La-Bruyère<br><a href='tel:065 61 34 00' class='tel'>065 61 34 00</a>",
            50.350811,
            3.860949,
          ],
          [
            "<strong>La Charmille</strong>Maison de repos et de soins<br>Rue Des Vignoles 2<br>6230 Thiméon<br><a href='tel:071 34 10 12' class='tel'>071 34 10 12</a>",
            50.48983218609029,
            4.4288682655245895,
          ],
        ];

        const map = L.map(mapElement).setView([50.5, 3.8], 10);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> Contributors',
          maxZoom: 18,
        }).addTo(map);

        const jolimontIcon = L.icon({
          iconUrl:
            "/themes/custom/expansion/assets/dist/images/jolimont-map-icon-senior.png",
          iconSize: [64, 64],
          iconAnchor: [32, 32],
          popupAnchor: [0, -30],
        });

        const markerArray = planes.map(([popupText, lat, lng]) => {
          return L.marker([lat, lng], { icon: jolimontIcon })
            .bindPopup(popupText, { minWidth: "250" })
            .addTo(map);
        });

        const group = L.featureGroup(markerArray);
        map.fitBounds(group.getBounds());
      }
    },
  };
})(Drupal, drupalSettings);
